import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography } from '@mui/material';
import { GoogleMap } from '../../../GoogleMapV4';
import { useMemo } from 'react';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const MapCardWidget = () => {
    const component = useMemo(() => (_jsxs(Grid, { container: true, rowSpacing: 1, children: [_jsx(Grid, { size: 12, children: _jsx(Typography, { variant: "h5", children: "GoogleMap" }) }), _jsx(Grid, { sx: { width: 400, height: 400 }, children: _jsx(GoogleMap, {}) })] })), []);
    return {
        name: 'MapCard',
        category: 'composite',
        component,
    };
};
